import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBBtn,
} from "mdbreact";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditExpense from "./AddEditExpense";
import AddEditDealer from "./AddEditDealer";
import DealerPrices from "./DealerPrices";

const Dealers = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);
  const [showPreloader, setPreloader] = useState("normal");

  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = () => {
    showAddEdit(!modalAddEdit);
    loadData();
  };

  const [bRefresh, setRefresh] = useState(false);
  function refreshGrid() {
    setRefresh(!bRefresh);
    loadData();
  }

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(props.apiServer + "/dealerslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const useMountEffect = (functionName) => useEffect(functionName, []);

  useMountEffect(checkAdminAccess);

  useMountEffect(loadData);

  if (isAdmin == 0) {
    return (
      <React.Fragment>
        <AccessDenied />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <MDBRow className="mt-4 pt-4">
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <MDBRow>
              <MDBCol md="4"></MDBCol>
              <MDBCol md="4" className="text-center">
                <br />
                <img
                  src={props.deployURL + "/loading.gif"}
                  style={{ width: "300px", textAlign: "center" }}
                  alt="loading"
                />
                <br />
              </MDBCol>
              <MDBCol md="4"></MDBCol>
            </MDBRow>
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="8">
                  <h6
                    style={{ fontFamily: "Montserrat", fontWeight: "400" }}
                    className="display-5 blue-grey-text ml-1"
                  >
                    {" "}
                    Dealers LIBRARY
                  </h6>
                </MDBCol>
                <MDBCol md="4">
                  <a href="#" className="float-right" onClick={toggleAddEdit}>
                    {" "}
                    <MDBIcon
                      icon="plus"
                      size="2x"
                      className="blue-text"
                      title="Add New Employee"
                    />
                  </a>
                </MDBCol>
              </MDBRow>

              <MaterialTable
                title=""
                columns={[
                  { title: "", field: "code", hidden: true },
                  { title: "Dealer", field: "description" },
                  { title: "Area", field: "area" },
                ]}
                data={rows}
                options={{
                  search: true,
                  actionsColumnIndex: -1,
                  filtering: true,
                  detailPanelType: "single",
                }}
                detailPanel={[
                  {
                    icon: () => <MDBIcon icon="user" className="cyan-text" />,
                    openIcon: () => (
                      <MDBIcon icon="chevron-down" className="red-text" />
                    ),
                    tooltip: "Dealer Details",
                    render: (rowData) => {
                      return (
                        <React.Fragment>
                          <AddEditDealer
                            deployURL={props.deployURL}
                            apiServer={props.apiServer}
                            dealercode={rowData.code}
                            apiServerHybrid={props.apiServerHybrid}
                            toggleModal={toggleAddEdit}
                            refreshGrid={refreshGrid}
                          />
                        </React.Fragment>
                      );
                    },
                  },

                  {
                    icon: () => <MDBIcon icon="list" className="cyan-text" />,
                    openIcon: () => (
                      <MDBIcon icon="chevron-down" className="red-text" />
                    ),
                    tooltip: "Dealer Price List",
                    render: (rowData) => {
                      return (
                        <React.Fragment>
                          <DealerPrices
                            deployURL={props.deployURL}
                            apiServer={props.apiServer}
                            dealercode={rowData.code}
                            apiServerHybrid={props.apiServerHybrid}
                            toggleModal={toggleAddEdit}
                            refreshGrid={refreshGrid}
                          />
                        </React.Fragment>
                      );
                    },
                  },
                ]}
              />
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      <MDBModal
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="blue-gradient">
            <h5 className="h5-responsive white-text">
              <b>Add New Dealer</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditDealer
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              dealercode={""}
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleAddEdit}
              refreshGrid={refreshGrid}
            />
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>

      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default Dealers;
